export default "../css/6532ad1a3ba3ad3af40c838fe80356d4.ttf";